import TeacherTable from '@/components/organisms/Table/TeacherTable';

import { Button,Input, Tabs, TabItem } from 'components/atoms/index';
import { useLocation, useNavigate } from 'react-router-dom';

// 강사 리스트
export default function AcademyTeacherList() {


  return (    
    <main className='flex flex-1 justify-start pt-8 w-full bg-white md:bg-transparent'>
        <div className='flex flex-col w-full'>
            <div className='flex justify-between items-center'>
                <h1 className='heading1'>강사 관리</h1>
            </div>
                <section className='flex flex-1 w-full lg:px-0'>
                    <TeacherTable />
                </section>
            </div>
    </main>
  )
}